import PropTypes from 'prop-types'
import { formatRelativeTime } from '@utils/formatters'

/**
 * TimelineStep Component
 *
 * Represents a single step in the approval timeline
 *
 * @param {Object} stage - Stage configuration
 * @param {string} status - Step status (pending, active, completed)
 * @param {boolean} isLast - Is this the last step?
 * @param {Object} timelineData - Timeline entry data from API
 */
const TimelineStep = ({ stage, status, isLast, timelineData }) => {
  return (
    <div className={`timeline-step timeline-step--${status}`}>
      <div className="timeline-step__connector">
        <div className="timeline-step__icon">
          <span>{stage.icon}</span>
        </div>
        {!isLast && <div className="timeline-step__line" />}
      </div>

      <div className="timeline-step__content">
        <div className="timeline-step__header">
          <h4 className="timeline-step__title">{stage.label}</h4>
          {status === 'active' && <span className="timeline-step__badge">Current</span>}
          {status === 'completed' && <span className="timeline-step__badge-completed">✓</span>}
        </div>

        <p className="timeline-step__description">{stage.description}</p>

        {timelineData && (
          <div className="timeline-step__metadata">
            {timelineData.completed_at && (
              <div className="timeline-step__time">
                <span className="timeline-step__time-label">Completed:</span>
                <span className="timeline-step__time-value">
                  {formatRelativeTime(timelineData.completed_at)}
                </span>
              </div>
            )}

            {timelineData.first_name && (
              <div className="timeline-step__actor">
                <span className="timeline-step__actor-label">By:</span>
                <span className="timeline-step__actor-value">
                  {timelineData.first_name} {timelineData.last_name}
                </span>
              </div>
            )}

            {timelineData.metadata && (
              <div className="timeline-step__details">
                {timelineData.metadata.excused_count > 0 && (
                  <span className="timeline-step__detail">
                    {timelineData.metadata.excused_count} item(s) excused
                  </span>
                )}
                {timelineData.metadata.accepted_count > 0 && (
                  <span className="timeline-step__detail">
                    {timelineData.metadata.accepted_count} item(s) accepted
                  </span>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

TimelineStep.propTypes = {
  stage: PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
  status: PropTypes.oneOf(['pending', 'active', 'completed']).isRequired,
  isLast: PropTypes.bool.isRequired,
  timelineData: PropTypes.object,
}

export default TimelineStep
